import React from 'react';
import Txt from '../../inputs/textInput.js';
import { MappingAliases } from './aliasMappingPath';

export default function UserMenuDropdown(props) {
  // Help Menu Option
  const helpMenuOptions = [
    {
      text: APP.LANGUAGE.HelpMenu.AboutThisPage,
      className: props.itemClass,
      onClick: () => props.HelpWithThisPageOnClick(),
      show: !props.redirectToPageNotFound && !props.redirectToPageFeatureUnavailable && !props.hideHelpAboutThisPage,
    },
    {
      text: APP.LANGUAGE.HelpMenu.ConsoleHelp,
      className: props.subMenuItemParentClass,
      subMenuClass: 'left menu sub-menu-items quick-view-help-subMenu',
      subMenuOption: [
        {
          text: APP.LANGUAGE.ConsoleHelpMenu.GetttingStarted,
          onClick: () => window.open(MappingAliases.getStarted, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.ConsoleHelpMenu.WaitingAreas,
          onClick: () => window.open(MappingAliases.waitingAreas, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.ConsoleHelpMenu.MeetingRooms,
          onClick: () => window.open(MappingAliases.meetingRooms, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.ConsoleHelpMenu.Reports,
          onClick: () => window.open(MappingAliases.reports, 'mgt-console-help'),
        },
      ],
    },
    {
      text: APP.LANGUAGE.HelpMenu.Posters,
      className: props.subMenuItemParentClass,
      subMenuClass: 'left menu sub-menu-items quick-view-help-subMenu',
      subMenuOption: [
        {
          text: APP.LANGUAGE.PostersMenu.BeginConsultation,
          onClick: () => window.open(MappingAliases.beginconsultPDF, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.PostersMenu.AttendMeeting,
          onClick: () => window.open(MappingAliases.attendmeetingPDF, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.PostersMenu.PostersCallScreen,
          onClick: () => window.open(MappingAliases.callscreenPDF, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.PostersMenu.PostersTroubleshooting,
          onClick: () => window.open(MappingAliases.usertroubleshooting, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.PostersMenu.AllPosters,
          onClick: () => window.open(MappingAliases.posters, 'mgt-console-help'),
        },
      ],
    },
    {
      text: APP.LANGUAGE.HelpMenu.TechnicalGuide,
      className: props.itemClass,
      onClick: () => window.open(MappingAliases.techguide, 'mgt-console-help'),
    },
    {
      text: APP.LANGUAGE.HelpMenu.TestVideoCall,
      className: props.itemClass,
      onClick: () => window.open(MappingAliases.testVideoCall, 'mgt-console-help'),
    },
    {
      text: APP.LANGUAGE.HelpMenu.Support,
      className: props.itemClass,
      onClick: () => window.open(MappingAliases.support, 'mgt-console-help'),
    },
    {
      text: APP.LANGUAGE.HelpMenu.ResourceCentre,
      className: props.itemClass,
      onClick: () => window.open(MappingAliases.resourcecentre, 'mgt-console-help'),
      show: props.user && props.user.featuresEnabled && props.user.featuresEnabled.resourceCentre,
    },
    {
      text: APP.LANGUAGE.HelpMenu.About,
      className: props.subMenuItemParentClass,
      subMenuClass: `${props.subMenuClass} ${props.subMenuHeightForAboutTab}`,
      subMenuOption: [
        {
          text: APP.LANGUAGE.AboutVideoCallMenu.Introducing.replace(
            '##PlatformInstanceName##',
            APP.CONFIGURATION.PORTAL.VideoCallPlatformName
          ),
          onClick: () => window.open(MappingAliases.intro, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.AboutVideoCallMenu.VideoCallNew,
          onClick: () => window.open(MappingAliases.new, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.AboutVideoCallMenu.VideoCallTermOfUse,
          onClick: () => window.open(MappingAliases.terms, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.AboutVideoCallMenu.PrivacyStatement,
          onClick: () => window.open(MappingAliases.privacy, 'mgt-console-help'),
        },
        {
          text: APP.LANGUAGE.AboutVideoCallMenu.CookiePolicy,
          onClick: () => window.open(MappingAliases.cookies, 'mgt-console-help'),
        },
      ],
    },
  ];

  const helpMenuOptionTrigger = (
    <div className="displayInline fl">
      <i data-show={true} className="ui icon help text-size-xl pdbm color-white mrrnull" />
    </div>
  );

  return (
    <Txt
      semanticui
      dropdown
      MenuClassName="menu-bar-dropdown"
      trigger={props.trigger ? props.trigger : helpMenuOptionTrigger}
      normalSemanticUI={props.normalSemanticUI}
      className={props.helpMenuClassName}
      id={props.id}
      options={helpMenuOptions}
      childOnClickfunc={props.childOnClickfunc}
    />
  );
}
